/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Administration {

    @Serenity.Decorators.registerClass()
    export class agentStatusOnlineGrid extends NoboxEntityGrid<UserRow, any> {
        protected getColumnsKey() { return agentStatusColumn.columnsKey; }
        protected getDialogType() { return UserDialog; }
        protected getIdProperty() { return UserRow.idProperty; }
        //protected getIsActiveProperty() { return UserRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserRow.localTextPrefix; }
        protected getService() { return UserService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("Agent Status");
        }
        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            return buttons;
        }

        //protected createToolbar(): void {
        //}

        //protected createQuickSearchInput(): void {
        //}

        protected getViewOptions() {
            let opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/ListAgentStatus')
            return opt;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as UserListRequest;
            request.IncludeColumns = ["TenantId", "DisplayName", "Email", "Online", "LastLogin"]
            //request.ColumnSelection = 1;
            return true;
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == UserRow.Fields.LastLogin);
            filter1.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["LastLogin"], ">=", start], "and", [["LastLogin"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["LastLogin"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["LastLogin"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    request.Criteria = null;
                    h.handled = true;
                }
            };

            var filter2 = Q.first(flt, x => x.field == UserRow.Fields.Online);
            filter2.handler = h => {
                const request = (h.request as UserListRequest);
                const indikator = (h.widget as IndikatorOnlineEditor).get_value();
                if (h.active) {
                    request.Online = indikator;
                    h.handled = true;
                } else {
                    request.Online = null;
                    h.handled = true;
                }
            };
            return flt;
        }
    }
}